import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';
import {
  detailsList,
  listView,
  list_AIView,
  like_unlike,
  payment_status
} from './api';

const initialState = {
  loading: false,
  user_data: [],
  user_payment_data: [],
  list_data: [],
  list_pagination: [],
  list_AIdata: [],
  aiacceptedLoading: false,
  user_profile_data: []
};

const actions = {
  GET_BYID: 'get_byID/GET_BYID',
  GET_LISTVIEW: 'get_listView/GET_LISTVIEW',
  GETAIDATA_LIST: 'getAIData_list/GETAIDATA_LIST',
  LIKEDPROFILE: 'likeProfile/LIKEDPROFILE',
  UNLIKEDPROFILE: 'unlikeProfile/UNLIKEDPROFILE',
  GET_PAYMENT_ID: 'get_Payment_ID/GET_PAYMENT_ID'
};

export const get_byID = createAsyncThunk(actions.GET_BYID, async (payload) => {
  console.log('get_byID', payload);
  const response = await detailsList(payload);
  return response;
});

// get_Payment_ID/GET_PAYMENT_ID
export const get_Payment_ID = createAsyncThunk(
  actions.GET_PAYMENT_ID,
  async () => {
    const response = await payment_status();
    return response;
  }
);

// get_listView/GET_LISTVIEW
export const get_listView = createAsyncThunk(
  actions.GET_LISTVIEW,
  async (payload) => {
    console.log('get_listView', payload);
    const response = await listView(payload);
    return response;
  }
);

// getAIData_list/GETAIDATA_LIST
export const getAIData_list = createAsyncThunk(
  actions.GETAIDATA_LIST,
  async (payload) => {
    // console.log('list_AIView', payload);
    const response = await list_AIView(payload);
    return response;
  }
);

// likeProfile/LIKEDPROFILE
export const likeProfile = createAsyncThunk(
  actions.LIKEDPROFILE,
  async (payload) => {
    const response = await like_unlike('mark-favourite', payload);
    return response;
  }
);

// unlikeProfile/UNLIKEDPROFILE
export const unlikeProfile = createAsyncThunk(
  actions.UNLIKEDPROFILE,
  async (payload) => {
    const response = await like_unlike('unmark-favourite', payload);
    return response;
  }
);

export const accessUser = createSlice({
  name: 'listDashboard',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(get_byID.pending, (state) => {
        state.acceptedLoading = true;
      })
      .addCase(get_byID.fulfilled, (state, action) => {
        const { data } = action.payload;
        // console.log('slice_View', action.payload);
        // state.allOnBoardingList = data.items ? data.items : [];
        // state.pagination = data.meta || null;
        state.user_data = data;
        // state.user_payment_data = data?.is_subscribed;
        console.log('slice_data12345', data);

        // console.log('slicelog', data);
      })
      .addCase(get_byID.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.acceptedLoading = false;
        message.error(msg);
      });

    // get_listView
    builder
      .addCase(get_listView.pending, (state) => {
        state.acceptedLoading = true;
      })
      .addCase(get_listView.fulfilled, (state, action) => {
        const { data, pagination } = action.payload;
        // console.log('slice_View', action.payload);
        // state.allOnBoardingList = data.items ? data.items : [];
        // state.pagination = data.meta || null;
        state.list_data = data;
        state.list_pagination = pagination;
      })
      .addCase(get_listView.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.acceptedLoading = false;
        message.error(msg);
      });

    // getAIData_list
    builder
      .addCase(getAIData_list.pending, (state) => {
        state.aiacceptedLoading = true;
      })
      .addCase(getAIData_list.fulfilled, (state, action) => {
        const { data, pagination } = action.payload;
        // console.log('slice_View', action.payload);
        // state.allOnBoardingList = data.items ? data.items : [];
        // state.pagination = data.meta || null;
        state.list_AIdata = data;
        state.list_pagination = pagination;
        state.aiacceptedLoading = false;
      })
      .addCase(getAIData_list.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.aiacceptedLoading = false;
        message.error(msg);
      });

    // likeProfile
    builder
      .addCase(likeProfile.pending, (state) => {
        state.loading = true;
      })
      .addCase(likeProfile.fulfilled, () => {
        // const { data } = action.payload;
        // console.log('slice_View', action.payload);
        // state.list_AIdata = data;
        // console.log('slice_data', data);
      })
      .addCase(likeProfile.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.loading = false;
        message.error(msg);
      });

    // unlikeProfile
    builder
      .addCase(unlikeProfile.pending, (state) => {
        state.loading = true;
      })
      .addCase(unlikeProfile.fulfilled, () => {
        // const { data } = action.payload;
        // console.log('slice_View', action.payload);
        // state.list_AIdata = data;
        // console.log('slice_data', data);
      })
      .addCase(unlikeProfile.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.loading = false;
        message.error(msg);
      });

    // get_Payment_ID
    builder
      .addCase(get_Payment_ID.pending, (state) => {
        state.acceptedLoading = true;
      })
      .addCase(get_Payment_ID.fulfilled, (state, action) => {
        const { data } = action.payload;
        // state.user_data = data;
        // console.log('slice_View12345', data?.is_subscribed);
        state.user_payment_data = data?.is_subscribed;
        state.user_profile_data = data;
        // console.log('slice_data12345', data);

        // console.log('slicelog', data);
      })
      .addCase(get_Payment_ID.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.acceptedLoading = false;
        message.error(msg);
      });
  }
});

export default accessUser.reducer;
